import { Dic } from '$utils'

const tableOption = {
  add: '新增',
  edit: '修改',
  view: '查看',
  page: true,
  selection: false,
  index: false,
  viewDialogHeight: 400,
  viewFormSlot: true,
  labelSuffix: '：',
  labelWidth: "140",
  column: [
    {
      label: '巡检点名称',
      prop: 'fireassetName',
      search: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      overHidden: true,
      span: 12
    },
    {
      label: '巡检类型',
      prop: 'fireassetType',
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      overHidden: true,
      align: 'center',
      span: 12,
      viewFormatter: (row, value) => {
        if (value) {
          return Dic.findByValue('SENU105', Number(value))
        }
        return ''
      },
      formatter: function (row, value) {
        return value ? Dic.findByValue('SENU105', value) : ''
      }
    },
    {
      label: '资产信息',
      prop: 'fireassetDetail',
      span: 24,
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      hide: true,
      formslot: true,
      viewslot: true,
      overHidden: true
      // rules: [{ required: true, message: '请输入资产名称', trigger: 'blur' }]
    },
    {
      label: '所在楼栋',
      prop: 'buildingName',
      search: true,
      searchSlot: true,
      editDisplay: true,
      viewDisplay: false,
      overHidden: true,
      hide: true,
      span: 12
    },
    {
      label: '所属楼栋/楼层',
      prop: 'buildingAndfloorName',
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      overHidden: true,
      span: 12
    },
    {
      label: '管理人',
      prop: 'personnelNames',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      overHidden: true,
      span: 12
    },
    {
      label: '管理人部门',
      prop: 'departmentNames',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      overHidden: true,
      span: 12
    },
    {
      label: '巡检人',
      prop: 'inspectorName',
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      overHidden: true,
      span: 24
    },
    {
      label: '计划开始时间',
      hide:true,
      prop: 'planStartTime',
      viewDisplay: true,
      overHidden: true,
      span: 12
    },
    {
      label: '计划结束时间',
      hide:true,
      prop: 'planEndTime',
      viewDisplay: true,
      overHidden: true,
      span: 12
    },
    {
      label: '巡检完成时间',
      prop: 'inspectorTime',
      search: true,
      searchSlot: true,
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      overHidden: true,
      span: 24
    },
    {
      label: '巡检状态',
      prop: 'status',
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      overHidden: true,
      formslot: true,
      viewslot: true,
      span: 12
    },
    {
      label: '巡检结果',
      prop: 'inspectionResult',
      type: 'select',
      search: true,
      dicData: [
        {
          label: '正常',
          value: '1'
        },
        {
          label: '异常',
          value: '2'
        }
      ],
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      overHidden: true,
      formslot: true,
      viewslot: true,
      viewFormSlot: true,
      span: 12,
      formatter: function (row, value) {
        let label = ''
        this.dicData.forEach((item) => {
          if (item.value === value) {
            label = item.label
          }
        })
        return label
      },
      viewFormatter: function (row, value) {
        let label = ''
        this.dicData.forEach((item) => {
          if (item.value === value) {
            label = item.label
          }
        })
        return label
      }
    },
    // {
    //   label: '问题图片',
    //   prop: 'picFileCode',
    //   viewDisplay: true,
    //   overHidden: true,
    //   formslot: true,
    //   viewslot: true,
    //   span: 12

    // },
    // {
    //   label: '问题视频',
    //   prop: 'videoFileCode',
    //   viewDisplay: true,
    //   overHidden: true,
    //   formslot: true,
    //   viewslot: true,
    //   span: 12

    // },
    {
      label: '巡检异常项',
      prop: 'patrolItemNames',
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      overHidden: true,
      formslot: true,
      viewslot: true,
      span: 12
    },
    {
      label: '异常项',
      prop: 'patrolItemRecordInfoList',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      viewDisplay: false,
      overHidden: true,
      viewslot: true,
      span: 12
    },
    {
      label: '审核人',
      prop: 'reviewerName',
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      overHidden: true,
      span: 12
    },
    {
      label: '审核时间',
      prop: 'reviewerTime',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      overHidden: true,
      span: 12
    },
    {
      label: '巡检周期',
      prop: 'planCycle',
      viewDisplay: true,
      overHidden: true,
      type: 'select',
      search: true,
      align: 'center',
      span: 12,
      dicData: Dic.find('SENU106'),
      viewFormatter: (row, value) => {
        if (value) {
          return Dic.findByValue('SENU106', Number(value))
        }
        return ''
      },
      formatter: function (row, value) {
        if (value) {
          return Dic.findByValue('SENU106', Number(value))
        }
        return ''
      }
    },
    {
      label: '问题描述',
      prop: 'inspectionDesc',
      hide: true,
      viewDisplay: true,
      overHidden: true,
      span: 24
    },
    {
      label: '巡检备注',
      prop: 'inspectionRemark',
      hide: true,
      viewDisplay: true,
      overHidden: true,
      span: 24
    }
  ]
}
export default tableOption
